import { render, staticRenderFns } from "./CreateStoreProduct.vue?vue&type=template&id=1b360a6e&scoped=true"
import script from "./CreateStoreProduct.vue?vue&type=script&lang=js"
export * from "./CreateStoreProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateStoreProduct.vue?vue&type=style&index=0&id=1b360a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b360a6e",
  null
  
)

export default component.exports